// extracted by mini-css-extract-plugin
module.exports = {"button":"button__Dmjkp","buttonGroup":"buttonGroup__+x+2A","dialog":"dialog__EBeDQ","dialogBody":"dialogBody__H3jxf","p":"p__A9OKW","switch":"switch__gn3gH"};